import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=474332ad&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=474332ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474332ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474332ad')) {
      api.createRecord('474332ad', component.options)
    } else {
      api.reload('474332ad', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=474332ad&scoped=true", function () {
      api.rerender('474332ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/gift/detail.vue"
export default component.exports